export default "__VITE_ASSET__BtUUtfSr__"